import hrStrategy from './hr-strategy';
import hrGrow from './hr-grow';
import hrHierarchy from './hr-hierarchy';
import productSupport from './product-support';
import productSpread from './product-spread';
import productDesign from './product-design';
import itBuild from './it-build';
import itManage from './it-manage';
import itSchema from './it-schema';
import trainFlow from './train-flow';
import trainKnowledge from './train-knowledge';
import ecologyBuild from './ecology-build';
import ecologyCooperate from './ecology-cooperate';
import ecologyStrategy from './ecology-strategy';

const banner = {
  title: '综合服务',
  description: '为您提供一站式解决方案，包括人力资源、产品运营、IT、综合培训、生态赋能等服务。',
  bg: '/imgs/service/banner.png'
};

const menu = [
  {
    key: 'hr',
    title: '人力资源',
    children: [
      {key: 'strategy', title: '人力资源战略'},
      {key: 'grow', title: '组织发展'},
      {key: 'hierarchy', title: '人力资源体系'}
    ]
  },
  {
    key: 'product',
    title: '产品运营',
    children: [
      {key: 'support', title: '政府类项目全流程申报支持'},
      {key: 'spread', title: '平台部署及运营推广'},
      {key: 'design', title: '财务及税务筹划服务'}
    ]
  },
  {
    key: 'it',
    title: 'IT',
    children: [
      {key: 'schema', title: 'IT规划'},
      {key: 'manage', title: 'IT治理'},
      {key: 'build', title: 'IT系统建设'}
    ]
  },
  {
    key: 'train',
    title: '综合培训',
    children: [
      {key: 'flow', title: '流程变革方法论'},
      {key: 'knowledge', title: '知识转移与培训'}
    ]
  },
  {
    key: 'ecology',
    title: '生态赋能',
    children: [
      {key: 'strategy', title: '生态战略'},
      {key: 'build', title: '生态构建'},
      {key: 'cooperate', title: '生态资源合作'}
    ]
  }
];

const list = {
  'hr-strategy': hrStrategy,
  'hr-grow': hrGrow,
  'hr-hierarchy': hrHierarchy,
  'product-spread': productSpread,
  'product-support': productSupport,
  'product-design': productDesign,
  'it-schema': itSchema,
  'it-build': itBuild,
  'it-manage': itManage,
  'train-knowledge': trainKnowledge,
  'train-flow': trainFlow,
  'ecology-strategy': ecologyStrategy,
  'ecology-cooperate': ecologyCooperate,
  'ecology-build': ecologyBuild
};

export {banner, menu, list};


// WEBPACK FOOTER //
// ./src/routes/Service/config/index.js